/*
 * Printtex : temps forts (fêtes, événements) — période en cours, pour l'onglet Idées de l'outil, la fiche, l'accueil
 * et les collections. Données : assets/printtex-temps-forts.json (calendrier) et assets/printtex-modeles.json (idées).
 *
 *   await PrinttexTempsForts.enCours()  →  [{ id, nom, resume, produits: [handles], idees: [{ id, nom, url }] }]
 *   (url = fiche du 1er produit conseillé, outil ouvert sur l'onglet Idées avec cette idée posée : ?idees=1&modele=<id>)
 *   PrinttexTempsForts.periodes(tf, date)  →  périodes du calendrier actives à cette date (synchrone, sans les noms)
 */
(() => {
  if (window.PrinttexTempsForts) return;
  const src = document.currentScript?.src || '';
  const url = (nom) => src.replace(/printtex-temps-forts\.js[^/]*$/, nom);

  const jour = (a, m, d) => new Date(Date.UTC(a, m - 1, d));
  const plus = (d, n) => new Date(d.getTime() + n * 86400000);
  function paques(a) { // calcul de Meeus
    const b = a % 19; const c = Math.floor(a / 100); const d = a % 100;
    const h = (19 * b + c - Math.floor(c / 4) - Math.floor((8 * c + 13) / 25) + 15) % 30;
    const l = (32 + 2 * (c % 4) + 2 * Math.floor(d / 4) - h - (d % 4)) % 7;
    const n = h + l - 7 * Math.floor((b + 11 * h + 22 * l) / 451) + 114;
    return jour(a, Math.floor(n / 31), (n % 31) + 1);
  }
  const dimanche = (a, m, rang) => { // rang-ième dimanche du mois (rang < 0 : le dernier)
    if (rang > 0) { const d = jour(a, m, 1); return plus(d, ((7 - d.getUTCDay()) % 7) + (rang - 1) * 7); }
    const d = jour(a, m + 1, 0); return plus(d, -d.getUTCDay());
  };
  function dateMobile(nom, a) {
    if (nom === 'paques') return paques(a);
    if (nom === 'grands-meres') return dimanche(a, 3, 1);
    if (nom === 'fete-peres') return dimanche(a, 6, 3);
    if (nom === 'fete-meres') { // dernier dimanche de mai, ou premier de juin si c'est la Pentecôte
      const d = dimanche(a, 5, -1);
      return d.getTime() === plus(paques(a), 49).getTime() ? dimanche(a, 6, 1) : d;
    }
    return null;
  }
  function periodes(tf, ici = new Date()) {
    if (!tf) return [];
    const a = ici.getFullYear();
    const auj = jour(a, ici.getMonth() + 1, ici.getDate());
    const md = (s, an) => { const [m, d] = s.split('-').map(Number); return jour(an, m, d); };
    return tf.periodes.filter((p) => {
      if (p.toujours) return false;
      if (p.dates) return p.dates.some(([d, f]) => auj >= new Date(`${d}T00:00:00Z`) && auj <= new Date(`${f}T00:00:00Z`));
      if (p.mobile) return [a, a + 1].some((an) => { const d = dateMobile(p.mobile, an); return d && auj >= plus(d, -(p.avant || 0)) && auj <= plus(d, p.apres || 0); });
      const debut = md(p.debut, a); const fin = md(p.fin, a);
      return fin >= debut ? auj >= debut && auj <= fin : auj >= debut || auj <= fin;
    });
  }
  let donnees = null;
  const charger = (tfUrl, modelesUrl) => {
    donnees ||= Promise.all([
      fetch(tfUrl || url('printtex-temps-forts.json')).then((r) => r.json()),
      fetch(modelesUrl || url('printtex-modeles.json')).then((r) => r.json()).catch(() => null),
    ]);
    return donnees;
  };
  async function enCours(ici = new Date()) {
    const [tf, biblio] = await charger();
    const noms = new Map((biblio?.modeles || []).map((m) => [m.id, m.nom]));
    return periodes(tf, ici).map((p) => ({
      id: p.id, nom: p.nom, resume: p.resume || p.nom, produits: p.produits || [],
      idees: p.idees.map((id) => ({ id, nom: noms.get(id) || id, url: `/products/${(p.produits || [])[0] || 't-shirt-basic-noir'}?idees=1&modele=${encodeURIComponent(id)}` })),
    }));
  }
  window.PrinttexTempsForts = { enCours, periodes, charger, dateMobile };
})();
